import { graphql } from 'gatsby';
import React from 'react';
import GlobalLayout from '../components/common/Layout';
import SeoHelmet from '../components/common/SeoHelmet';
import PremierSavingsComponent from '../components/premier-savings';

const PremierSavings = ({ data, location, pageContext: { relatedArticles } }) => {
  const { markdownRemark } = data;
  const {
    fields: { slug: url },
    frontmatter: {
      showNavigation = true,
      hero,
      banner,
      infoTypes,
      lowerCostSection,
      savingsCalculator,
      rewards,
      downloadApps,
      seo,
      legal,
      notice,
      withNydigNotice,
      faq
    }
  } = markdownRemark;

  return (
    <GlobalLayout
      {...{
        showNavigation,
        legal,
        margin: false,
        notice,
        withNydigNotice,
        bgColor: 'backgroundPrimary',
        location
      }}
    >
      <SeoHelmet {...{ ...seo, url }} />
      <PremierSavingsComponent
        {...{
          hero,
          banner,
          infoTypes,
          lowerCostSection,
          savingsCalculator,
          rewards,
          downloadApps,
          location,
          faq,
          relatedArticles
        }}
      />
    </GlobalLayout>
  );
};

export const pageQuery = graphql`
  query Page($id: String!) {
    markdownRemark(id: { eq: $id }) {
      fields {
        slug
      }
      frontmatter {
        seo {
          title
          description
          image
          blockRobots
        }
        showNavigation
        hero {
          caption
          title
          subtitle
          image
          cardImage
          imageWidth
          imageHeight
          isWidescreenImage
          hideImageOnMobile
          imageWithTopMargin
          imageWithLeftMargin
          backgroundColor
          insuranceText
          showWhiteActionButton
          learnMoreLinkUrl
          highlights {
            item
          }
          tripleCash {
            text
            link
          }
          bulletColor
          bulletType
          ctaButtonText
          ctaButtonAriaLabel
          ctaLinkUrl
          ctaButtonName
          ctaSticky
          ctaCaption
          fullWidthTitle
          displayContactForm
          displayContactFormCaptcha
          displayMerchantContactForm
          displayMerchantContactFormCaptcha
          fontColor
          titleColor
          alignImageTop
          productOverview {
            title
            description
          }
        }
        banner {
          backgroundColor
          primaryText
          primaryTextColor
          secondaryText
          secondaryTextColor
        }
        infoTypes {
          title
          subtitle
          backgroundColor
          fontColor
          columns
          alignItems
          items {
            image
            imageWidth
            imageHeight
            imagePosition
            title
            description
          }
        }
        lowerCostSection {
          title
          subtitle
          headline
          subheadline
          backgroundColor
          table {
            description
            firstHeading
            secondHeading
            firstRow
            secondRow
            thirdRow
            firstFootnote
            secondFootnote
            thirdFootnote
          }
        }
        savingsCalculator {
          apy
          title
          subtitle
          ctaLinkUrl
          ctaButtonText
          ctaButtonAriaLabel
          headerSubtitle
          headerTooltip
          inputHint
          inputLabel
          totalSavings
          totalSavingsTooltip
          totalInterest
          totalInterestTooltip
          yearsBarTitle
        }
        downloadApps {
          backgroundColor
          innerColor
          titleColor
          title
          subTitle
          image
          imageHeight
          imageWidth
          flipLayout
          highlights {
            color
            icon
            iconColor
            items {
              text
            }
            size
          }
          qrCodeImg
          qrCodeImgAlt
          qrCodeImgHeight
          qrCodeImgWidth
          qrCodeText
          textColor
          titleSize
        }
        faq {
          title
          layout
          items {
            notice
            question
            answer
          }
          showFAQ
        }
        legal
        notice
        withNydigNotice
      }
    }
  }
`;

export default PremierSavings;
